import React, { useState, Alert } from 'react';
import api from '../../services/api';
import $ from 'jquery';
import FirebaseService from '../../services/firebase';

export default function Login({ history }) {
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');


    async function handleSubmit(event) {
        event.preventDefault();
        try {
            await FirebaseService.login(email, password)
            history.push('/dashboard');

        }
        catch (error) {
            console.log(error)
            showErrorMessage(error.message)
        }
    }

    function showErrorMessage(message) {
        setError(message);
        $(".alert").fadeTo(5000, 500).slideUp(500, function(){
            $(".alert").slideUp(500);
        });
    }

    return (
        <>
            <div className="alert alert-warning alert-dismissible fade" role="alert">
                {error}
            </div>
            <p>Gerencie suas reuniões</p>

            <form onSubmit={handleSubmit}>
                <label htmlFor="email">Email *</label>
                <input
                    type="email"
                    id="email"
                    placeholder="coloque seu email"
                    value={email}
                    onChange={event => { setEmail(event.target.value) }}
                />

                <label htmlFor="email">Senha *</label>
                <input
                    type="password"
                    id="password"
                    placeholder="coloque sua senha"
                    value={password}
                    onChange={event => { setPassword(event.target.value) }}
                />

                <button className="btn" type="submit">Entrar</button>
            </form>
        </>
    )
}